import axios from "axios";
import { BaseClient } from "../../../services";
import { AtualizarCobrancaAnuncioDTO, AtualizarPagamentoAdminDTO, CriarAnuncioDTOV2, CriarVeiculoAnuncioDTO, NewAdsOrVehicleDTO, NovoAnuncioComboDTO, NovoComboAnuncioDTO, RenovarAdDto } from "../dto/CompanyDTO";

export const fetchCompanies = async (userId?: number) => {
    try {
    const response =await BaseClient.get("/Admin/Anuncios/Get/Concessionarias/Form", {params:{usuario_id: userId}});
    return response.data;
    } catch (error: any) {
        return error.response.message ?? "Erro. Contate o administrador.";
    }
}

export const fetchMarcas = async (tipo: number) => {
    try {
        const response = await BaseClient.get(`/Admin/Anuncios/Get/Marcas/Form/${tipo}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success: false, message:"Error. Contate o administrador."};
    }
}

export const fetchModelo = async (marcaId: number) => {
    try {
        const response = await BaseClient.get(`/Admin/Anuncios/Get/Modelo/Form/${marcaId}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success: false, message:"Error. Contate o administrador."};
    }
}

export const onSubmitNewAdsOrVehicle = async (dto: NewAdsOrVehicleDTO) => {
    try {
        const response = await BaseClient.post("/Anuncios", dto);
        return response;
    } catch (error: any) {
        return error.response;
    }
}

export const onSubmitUpdateAds = async (dto: NewAdsOrVehicleDTO, adId: number) => {
    try {
        const response = await BaseClient.put(`/Anuncios/${adId}`, dto);
        return response;
    } catch (error: any) {
        return error.response;
    }
}


export const fetchAdById = async (adId: number) => {
    try {
        const response = await BaseClient.get(`/Admin/Anuncios/Get/Detalhe-Anuncio`, {params:{
          idAnuncio: adId
        }});
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success: false, message:"Erro. Contate o administrador."};
    }
};

export const fetchVeiculoEdit = async (adId: number) => {
    try {
        const response = await BaseClient.get(`/Admin/Anuncios/Get/Anuncio/Details/Edit`, 
          {
          params:{
          adId: adId
        }});
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success: false, message:"Erro. Contate o administrador."};
    }
};

export const updatePhotoCapa = async (veiculo_id: number,anuncio_id: number, foto: string) => {
  try {
    const response = await BaseClient.put(
      "/Admin/Anuncios/Update/PhotoCapaAd",
      {
        veiculo_id: veiculo_id,
        anuncio_id: anuncio_id,
        photo: foto,
      }
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data ?? error;
  }
};

export const deletePhoto = async (veiculo_id: number, foto: string) => {
  try {
    const response = await BaseClient.delete(
      "/Admin/Anuncios/Delete/PhotoAd",
      {
        data: {
          veiculo_id: veiculo_id,
          photo: foto,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const fetchAdDetailsById = async (adId: number) => {
    try {
        const response = await BaseClient.get(`/Admin/Anuncios/Get/Anuncio/Details/${adId}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success: false, message:"Erro. Contate o administrador."};
    }
};

export const fetchAdForPackage = async (userId: number, id_concessionaria: number) => {
    try {
        const response = await BaseClient.get("/Admin/Anuncios/Get/Anuncios/New/Package", {params: {usuarioId: userId, id_concessionaria: id_concessionaria}});
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success: false, message:"Erro. Por favor contate o Administrador."};
    }
};

export const postNovoComboDeAnuncios = async(dto: NovoComboAnuncioDTO) => {
    try {
        const response = await BaseClient.post("/Admin/Anuncios/Post/Criar/Anuncio", dto)
        return response.data;
    } catch (error:any) {
        return error.response.data ?? {success:false, message:"Erro. Contate o Administrador."};
    }
};

export const renovarAd = async (dto: RenovarAdDto, id: number) => {
        try {
        const response = await BaseClient.put(`/Admin/Anuncios/Put/Renovar-Ad/${id}`, dto)
        return response.data;
    } catch (error:any) {
        return error.response.data ?? {success:false, message:"Erro. Contate o Administrador."};
    }
};



export const createVehicle = async (dto: CriarVeiculoAnuncioDTO) => {
  try {
    const formData = new FormData();

    // ===== campos simples =====
    formData.append("id_concessionaria", dto.id_concessionaria.toString());
    formData.append("placa", dto.placa ??"");
    formData.append("tipo_veiculo", dto.tipo_veiculo??"");
    formData.append("marca", dto.marca??"");
    formData.append("modelo", dto.modelo??"");

    formData.append("ano_fabricacao", dto.ano_fabricacao.toString());
    formData.append("ano_modelo", dto.ano_modelo.toString());
    formData.append("km", dto.km.toString());

    if (dto.motor) formData.append("motor", dto.motor);
    if (dto.combustivel) formData.append("combustivel", dto.combustivel);
    if (dto.transmissao) formData.append("transmissao", dto.transmissao);
    if (dto.cor) formData.append("cor", dto.cor);
    if (dto.portas !== undefined)
      formData.append("portas", dto.portas.toString());

    formData.append("valor", dto.valor.toString());

    if (dto.observacao) formData.append("observacao", dto.observacao);
    if (dto.avarias) formData.append("avarias", dto.avarias);
    if (dto.codigo_fipe) formData.append("codigo_fipe", dto.codigo_fipe);
    if (dto.valor_fipe) formData.append("valor_fipe", dto.valor_fipe);

    // ===== arquivo laudo =====
    if (dto.laudo_file) {
      formData.append("laudo_file", dto.laudo_file);
    }

    // ===== lista de acessórios =====
    dto.acessorios.forEach((id, index) => {
      formData.append(`acessorios[${index}]`, id.toString());
    });

    // ===== fotos (upload múltiplo com objeto) =====
    dto.fotos.forEach((foto, index) => {
      formData.append(`fotos[${index}].foto`, foto.foto);
      formData.append(`fotos[${index}].capa`, foto.capa.toString());
    });

    const response = await BaseClient.post(
      "/Admin/Anuncios/Post/Criar/Veiculo-Anuncio",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error: any) {
    return (
      error?.response?.data ?? {
        success: false,
        message: "Erro ao criar anúncio de veículo",
      }
    );
  }
};

export const updateVeiculo = async (dto: CriarVeiculoAnuncioDTO, id_veiculo: number) => {
  try {
    const formData = new FormData();

    // ===== campos simples =====
    formData.append("id_concessionaria", dto.id_concessionaria.toString());
    formData.append("placa", dto.placa ??"");
    formData.append("tipo_veiculo", dto.tipo_veiculo??"");
    formData.append("marca", dto.marca??"");
    formData.append("modelo", dto.modelo??"");

    formData.append("ano_fabricacao", dto.ano_fabricacao.toString());
    formData.append("ano_modelo", dto.ano_modelo.toString());
    formData.append("km", dto.km.toString());

    if (dto.motor) formData.append("motor", dto.motor);
    if (dto.combustivel) formData.append("combustivel", dto.combustivel);
    if (dto.transmissao) formData.append("transmissao", dto.transmissao);
    if (dto.cor) formData.append("cor", dto.cor);
    if (dto.portas !== undefined)
      formData.append("portas", dto.portas.toString());

    formData.append("valor", dto.valor.toString());

    if (dto.observacao) formData.append("observacao", dto.observacao);
    if (dto.avarias) formData.append("avarias", dto.avarias);
    if (dto.codigo_fipe) formData.append("codigo_fipe", dto.codigo_fipe);
    if (dto.valor_fipe) formData.append("valor_fipe", dto.valor_fipe);

    // ===== arquivo laudo =====
    if (dto.laudo_file) {
      formData.append("laudo_file", dto.laudo_file);
    }

    // ===== lista de acessórios =====
    dto.acessorios.forEach((id, index) => {
      formData.append(`acessorios[${index}]`, id.toString());
    });

    if (dto.fotos?.length) {
    // ===== fotos (upload múltiplo com objeto) =====
    dto.fotos.forEach((foto, index) => {
      formData.append(`fotos[${index}].foto`, foto.foto);
      formData.append(`fotos[${index}].capa`, foto.capa.toString());
    });
    }



    const response = await BaseClient.put(
      "/Admin/Anuncios/Put/Update/Veiculo-Anuncio",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        params: {
          id_veiculo: id_veiculo
        }
      }
    );

    return response.data;
  } catch (error: any) {
    return (
      error?.response?.data ?? {
        success: false,
        message: "Erro ao criar anúncio de veículo",
      }
    );
  }
};

export const createAnuncioV2 = async (dto: CriarAnuncioDTOV2) => {
  try {
    const formData = new FormData();

    // ===== campos simples =====
    formData.append("id_concessionaria", dto.id_concessionaria.toString());
    formData.append("placa", dto.placa ??"");
    formData.append("tipo_veiculo", dto.tipo_veiculo??"");
    formData.append("marca", dto.marca??"");
    formData.append("modelo", dto.modelo??"");

    formData.append("ano_fabricacao", dto.ano_fabricacao.toString());
    formData.append("ano_modelo", dto.ano_modelo.toString());
    formData.append("km", dto.km.toString());

    if (dto.motor) formData.append("motor", dto.motor);
    if (dto.combustivel) formData.append("combustivel", dto.combustivel);
    if (dto.transmissao) formData.append("transmissao", dto.transmissao);
    if (dto.cor) formData.append("cor", dto.cor);
    if (dto.portas !== undefined)
      formData.append("portas", dto.portas.toString());

    formData.append("valor", dto.valor_inicial?.toString() ?? "");

    if (dto.observacao) formData.append("observacao", dto.observacao);
    if (dto.avarias) formData.append("avarias", dto.avarias);


    if (dto.data_leilao) formData.append("data_leilao", dto.data_leilao);
    if (dto.data_finalizacao) formData.append("data_finalizacao", dto.data_finalizacao);
    if (dto.valor_inicial) formData.append("valor_inicial", String(dto.valor_inicial));
    if (dto.compre_agora) formData.append("compre_agora", String(dto.compre_agora));
    if (dto.texto_padrao) formData.append("texto_padrao", dto.texto_padrao);
    if (dto.texto_padrao) formData.append("tipo_anuncio", dto.tipo_anuncio??"N");
    if (dto.codigo_fipe) formData.append("codigo_fipe", dto.codigo_fipe??"");
    if (dto.valor_fipe) formData.append("valor_fipe", dto.valor_fipe??"");

    // ===== arquivo laudo =====
    if (dto.laudo_file) {
      formData.append("laudo_file", dto.laudo_file);
    }

    // ===== lista de acessórios =====
    dto.acessorios.forEach((id, index) => {
      formData.append(`acessorios[${index}]`, id.toString());
    });

    // ===== fotos (upload múltiplo com objeto) =====
    dto.fotos.forEach((foto, index) => {
      formData.append(`fotos[${index}].foto`, foto.foto);
      formData.append(`fotos[${index}].capa`, foto.capa.toString());
    });

    const response = await BaseClient.post(
      "/Admin/Anuncios/Post/Criar/Anuncio",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error: any) {
    return (
      error?.response?.data ?? {
        success: false,
        message: "Erro ao criar anúncio de veículo",
      }
    );
  }
};

export const putUpdateAnuncioV2 = async (dto: CriarAnuncioDTOV2, id_anuncio: number) => {
  try {
    const formData = new FormData();

    // ===== campos simples =====
    formData.append("id_concessionaria", dto.id_concessionaria.toString());
    formData.append("placa", dto.placa ??"");
    formData.append("tipo_veiculo", dto.tipo_veiculo??"");
    formData.append("marca", dto.marca??"");
    formData.append("modelo", dto.modelo??"");

    formData.append("ano_fabricacao", dto.ano_fabricacao.toString());
    formData.append("ano_modelo", dto.ano_modelo.toString());
    formData.append("km", dto.km.toString());
    if (dto.codigo_fipe) formData.append("codigo_fipe", dto.codigo_fipe??"");
    if (dto.valor_fipe) formData.append("valor_fipe", dto.valor_fipe??"");
    if (dto.motor) formData.append("motor", dto.motor);
    if (dto.combustivel) formData.append("combustivel", dto.combustivel);
    if (dto.transmissao) formData.append("transmissao", dto.transmissao);
    if (dto.cor) formData.append("cor", dto.cor);
    if (dto.portas !== undefined)
      formData.append("portas", dto.portas.toString());

    formData.append("valor", dto.valor_inicial?.toString() ?? "");

    if (dto.observacao) formData.append("observacao", dto.observacao);
    if (dto.avarias) formData.append("avarias", dto.avarias);


    if (dto.data_leilao) formData.append("data_leilao", dto.data_leilao);
    if (dto.data_finalizacao) formData.append("data_finalizacao", dto.data_finalizacao);
    if (dto.valor_inicial) formData.append("valor_inicial", String(dto.valor_inicial));
    if (dto.compre_agora) formData.append("compre_agora", String(dto.compre_agora));
    if (dto.texto_padrao) formData.append("texto_padrao", dto.texto_padrao);
    if (dto.texto_padrao) formData.append("tipo_anuncio", dto.tipo_anuncio??"N");

    // ===== arquivo laudo =====
    if (dto.laudo_file) {
      formData.append("laudo_file", dto.laudo_file);
    }

    // ===== lista de acessórios =====
    dto.acessorios.forEach((id, index) => {
      formData.append(`acessorios[${index}]`, id.toString());
    });

    // ===== fotos (upload múltiplo com objeto) =====
    dto.fotos.forEach((foto, index) => {
      formData.append(`fotos[${index}].foto`, foto.foto);
      formData.append(`fotos[${index}].capa`, foto.capa.toString());
    });

    const response = await BaseClient.put(
      `/Admin/Anuncios/Put/Atualizar/Anuncio?id_anuncio=${id_anuncio}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error: any) {
    return (
      error?.response?.data ?? {
        success: false,
        message: "Erro ao criar anúncio de veículo",
      }
    );
  }
};


export const fetchAnunciosCompany = async (
  search: string | null,
  tipo_anuncio?: string | null,
  data_inicio?: string | null,
  data_fim?: string | null
) => {
  try {
    const response = await BaseClient.get(`Anuncios/Get/Anuncios/Company`, {
      params: {
        search,
        tipo_anuncio,
        data_inicio: data_inicio || undefined,
        data_fim: data_fim || undefined,
      },
    });
    return response.data;
  } catch (error: any) {
    return error.response.data ?? { success: false, message: "Erro. Contate o Administrador." };
  }
};

export const fetchDashBoardComapny = async (  
  data_inicio?: string | null,
  data_fim?: string | null) => {
  try {
    const response = await BaseClient.get("Anuncios/Get/Dashboard-Comapny", {params: {
      data_inicio: data_inicio || undefined,
      data_fim: data_fim || undefined,
    }});
    return response.data;
  } catch (error:any) {
   return error.response.data ?? {success:false, message:"Erro. Contate o Administrador."};
  }
};

export const exportAnunciosPdf = async (
  search: string | null,
  tipo_anuncio?: string | null,
  data_inicio?: string | null,
  data_fim?: string | null
) => {
  try {
    const response = await BaseClient.get("Anuncios/Get/Export/Pdf", {
      responseType: "blob",
      params: {
        search: search || undefined,
        tipo_anuncio: tipo_anuncio || undefined,
        data_inicio: data_inicio || undefined,
        data_fim: data_fim || undefined,
      },
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `anuncios_${new Date().toISOString().slice(0, 10)}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar PDF." };
  }
};

export const exportAnunciosExcel = async (
  search: string | null,
  tipo_anuncio?: string | null,
  data_inicio?: string | null,
  data_fim?: string | null
) => {
  try {
    const response = await BaseClient.get("Anuncios/Get/Export/Excel", {
      responseType: "blob",
      params: {
        search: search || undefined,
        tipo_anuncio: tipo_anuncio || undefined,
        data_inicio: data_inicio || undefined,
        data_fim: data_fim || undefined,
      },
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `anuncios_${new Date().toISOString().slice(0, 10)}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar Excel." };
  }
};


export const putPublicaAnuncio = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.put(`/Admin/Anuncios/Put/Publica/anuncio?id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error:any) {
   return error.response.data ?? {success:false, message:"Erro. Contate o Administrador."};
  }
};
export const putDesativaAnuncio = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.put(`/Admin/Anuncios/Put/Desativar/anuncio?id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error:any) {
   return error.response.data ?? {success:false, message:"Erro. Contate o Administrador."};
  }
};

export const fetchFipe = async (  codigo_fipe: string,  ano_modelo: number ): Promise<string | null> => {
  try {
    const response = await axios.get(
      `https://brasilapi.com.br/api/fipe/preco/v1/${codigo_fipe}`
    );

    const veiculo = response.data?.find(
      (v: any) => v.anoModelo === ano_modelo
    );

    return veiculo?.valor ?? null;
  } catch {
    return null;
  }
};

export const criarAnuncioCombo = async (dto: NovoAnuncioComboDTO) => {
  try {
    const response = await BaseClient.post("/Admin/Anuncios/Post/Criar/Anuncio-Combo", dto);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};
export const upadteAnuncioCombo = async (dto: NovoAnuncioComboDTO, id_anuncio: number) => {
  try {
    const response = await BaseClient.put("/Admin/Anuncios/Put/Update/Anuncio-Combo", dto, {params: {
      id_anuncio: id_anuncio
    }});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};
export const renovaAnuncioCombo = async (dto: NovoAnuncioComboDTO, id_anuncio: number) => {
  try {
    const response = await BaseClient.put("/Admin/Anuncios/Put/Renova/Anuncio-Combo", dto, {params: {
      id_anuncio: id_anuncio
    }});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchComboAnuncioById = async (id_anuncio: number) => {
try {
  const response = await BaseClient.get(`/Admin/Anuncios/Get/Anuncio-Combo?id_anuncio=${id_anuncio}`);
  return response.data;
} catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const putPublicaAnuncioCombo = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.put(`/Admin/Anuncios/Put/Publicar/Anuncio-Combo?id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};
export const putDesativaAnuncioCombo = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.put(`/Admin/Anuncios/Put/Desativar/Anuncio-Combo?id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchPayments = async (search: string | null, initialDate: string | null, finalDate: string | null, type: string | null) => {
  try {
    const response = await BaseClient.get("/Admin/Anuncios/Get/Pagamentos/Vendas", {params: {
      search: search,
      data_inicial: initialDate,
      data_final: finalDate,
      tipo: type
    }});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};


export const fetchPaymentsDashboard = async () => {
  try {
    const response = await BaseClient.get("/Admin/Anuncios/Get/Dashboard/Pagamentos/Vendas");
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const renovarPagamento = async (id_pagamento: number) => {
  try {
    const response = await BaseClient.get("/Admin/Anuncios/Get/Renovar-Pagamento", {params:{
      id_pagamento: id_pagamento
    }});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
}

export const atualizarPagamento = async (dto: AtualizarPagamentoAdminDTO) =>  {
try {
  const response = await BaseClient.put("Admin/Anuncios/Put/Atualizar-Pagamento", dto);
  return response.data;
} catch (error: any) {
  return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
}
};


export const deletePagamento = async (id_pagamento: number) =>  {
try {
  const response = await BaseClient.delete(`Admin/Anuncios/Delete/Delete-Pagamento?id_pagamento=${id_pagamento}`);
  return response.data;
} catch (error: any) {
  return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
}
};

export const atualizarCobrancaAnuncio = async (dto: AtualizarCobrancaAnuncioDTO) => {
  try {
    const response = await BaseClient.put("Admin/Anuncios/Put/Atualizar-Cobranca-Anuncio", dto);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? { success: false, message: "Erro. Contate o administrador." };
  }
};

export const fetchRevendaInfoDetails = async (id_revenda: number) => {
  try {
    const response = await BaseClient.get(`Admin/Anuncios/Get/Revenda/Info?id_revenda=${id_revenda}`);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
};

export const fetchRevendasAtivas = async (search?: string) => {
  try {
    const response = await BaseClient.get("Admin/Anuncios/Get/Revendas", {
      params: search ? { search } : undefined,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data ?? { success: false, message: "Erro. Contate o administrador." };
  }
};

export const atualizarRevendaCompradora = async (id_anuncio: number, id_revenda: number) => {
  try {
    const response = await BaseClient.put("Admin/Anuncios/Put/Atualizar/Revenda-Compradora", null, {
      params: { id_anuncio, id_revenda },
    });
    return response.data;
  } catch (error: any) {
    return error.response.data ?? { success: false, message: "Erro. Contate o administrador." };
  }
};

export const fetchAnuncioAcesso = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.get(`Admin/Anuncios/Get/Anuncio/Acesso?id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }

 }

 export const fetchSalesReport = async (
  initialDate: string | null,
  finalDate: string | null,
  grupoId?: string | null,
  concessionariaId?: string | null,
 ) => {
  try {
    const response = await BaseClient.get("Admin/Anuncios/Get/Vendas/Detalhes", {params: {
      dat_inicial: initialDate,
      dat_final: finalDate,
      grupo_id: grupoId || undefined,
      concessionaria_id: concessionariaId || undefined,
    }});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
 }

 export const fetchSalesResum = async (
  initialDate: string | null,
  finalDate: string | null,
  grupoId?: string | null,
  concessionariaId?: string | null,
 ) => {
  try {
    const response = await BaseClient.get("Admin/Anuncios/Get/Vendas/Resumo", {params: {
      dat_inicial: initialDate,
      dat_final: finalDate,
      grupo_id: grupoId || undefined,
      concessionaria_id: concessionariaId || undefined,
    }});
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
 }
 export const exportSalesReportCsv = async (
  initialDate: string | null,
  finalDate: string | null,
  grupoId?: string | null,
  concessionariaId?: string | null,
 ) => {
  try {
    const response = await BaseClient.get("Admin/Anuncios/Get/Vendas/Detalhes/Csv", 
      {
      responseType: 'blob',
      params: {
      dat_inicial: initialDate,
      dat_final: finalDate,
      grupo_id: grupoId || undefined,
      concessionaria_id: concessionariaId || undefined,
    }});

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `vendas_detalhes_${initialDate}_${finalDate}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.Message ?? "Erro ao exportar CSV. Contate o administrador." };
  }
 }


 export const allowCotacao = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.post(`Admin/Anuncios/Post/Atualizar-Cotacao?num_id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
 }

 export const rejectCotacao = async (id_anuncio: number) => {
  try {
    const response = await BaseClient.put(`Admin/Anuncios/Put/Recusar-Cotacao?num_id_anuncio=${id_anuncio}`);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success:false, message:"Erro. Contate o administrador."};
  }
 }